import { Injectable, OnInit, OnDestroy } from "@angular/core";
import { HttpCommonService } from "./http-common.service";
import { BehaviorSubject, Observable, Subject, Unsubscribable } from "rxjs";
import { Lookup } from "../models";
import { LocalStoreManager } from './local-store-manager.service';
import { DBkeys } from './db-keys';
import { takeUntil } from 'rxjs/operators';
@Injectable(
  {
    providedIn: 'root'
  })
export class LookupService implements OnDestroy {
  _DBkeys = DBkeys;
  ngUnsubscribe = new Subject<void>();
  private data = new BehaviorSubject<Lookup[]>(this.localStorage.getDataObject<Lookup[]>(this._DBkeys.LOOK_UP_INFO) || []);
  private dataloding: boolean = false;
  constructor(protected httpCommonService: HttpCommonService, protected localStorage: LocalStoreManager) {
    this.getall();
  }
  async saveall() {
    if (!this.dataloding) {
      this.dataloding = true;
      await this.httpCommonService.getList('LookUp/LookupList')
        .pipe(takeUntil(this.ngUnsubscribe)).toPromise()
        .then((data: Lookup[]) => {
          if (data && data.length > 0) {
            this.localStorage.saveSessionData(data, this._DBkeys.LOOK_UP_INFO);
            this.data.next(data);
            this.dataloding = false;
          }
        }, err => this.dataloding = false);
    }
  }

  getall() {
    if (!this.localStorage.getDataObject<Lookup[]>(this._DBkeys.LOOK_UP_INFO)) {
      this.saveall();
    }
    if ((!this.data.getValue() || this.data.getValue().length <= 0)) {
      this.saveall();
    }
  }

  getLookupbyCategory(systemName: string, category: string): Observable<Lookup[]> {
    var abs = new BehaviorSubject<Lookup[]>([]);
    if (!this.data.getValue() || this.data.getValue().length <= 0)
      this.getall();
    this.data
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(d => {
        abs.next(d.filter(x => x.SystemName === systemName && x.Category === category));
      });
    return abs.asObservable();
  }
  getLookupbyCode(systemName: string, category: string, code: number): Observable<Lookup> {
    var abs = new BehaviorSubject<Lookup>(new Lookup());
    if (!this.data.getValue() || this.data.getValue().length <= 0)
      this.getall();
    let temp = this.data.getValue().filter(x => x.SystemName === systemName && x.Category === category && x.Code === code);
    if (temp && temp.length > 0)
      abs.next(temp[0] as Lookup);
    else {
      this.saveall();
      let temp = this.data.getValue().filter(x => x.SystemName === systemName && x.Category === category && x.Code === code);
      if (temp && temp.length > 0)
        abs.next(temp[0] as Lookup);
    }
    return abs.asObservable();
  }
  getLookupId(systemName: string, category: string, code: number): Observable<number> {
    var abs = new BehaviorSubject<number>(0);
    if (!this.data.getValue() || this.data.getValue().length <= 0)
      this.getall();
    let temp = this.data.getValue().filter(x => x.SystemName === systemName && x.Category === category && x.Code === code);
    if (temp && temp.length > 0)
      abs.next(temp[0].Id);
    return abs.asObservable();
  }
  getLookupbyId(Id: number): Lookup {
    if (!this.data.getValue() || this.data.getValue().length <= 0)
      this.getall();
    let temp = this.data.getValue().filter(x => x.Id === Id);
    if (temp && temp.length > 0)
      return temp[0];
    return null;
  }
  ngOnDestroy(): void {
    if (this.ngUnsubscribe) {
      this.ngUnsubscribe.next();
      this.ngUnsubscribe.complete();
    }
    this.data = undefined;
  }
}
